export default __webpack_public_path__ + "static/media/a2.49838e74.png";